import type BackOfficeConnector from "../data/backOfficeConnector";
import type { IPagedResults, IPagination } from "../data/types";
import type EventBus from "services/eventBus";
import RepositoryBase from "./repositoryBase";
import EnforcementTabletUserSearchRequest from "../entities/enforcementTabletUserSearchRequest";
import EnforcementTabletUserDetailResponse from "entities/enforcementTabletUserDetailResponse";
import EnforcementTabletUserCreateRequest from "../entities/enforcementTabletUserCreateRequest";
import type EnforcementTabletUserResponse from "entities/enforcementTabletUserResponse";
import { serializeFilters } from "utils/filters";

export default class EnforcementUserRepository extends RepositoryBase<BackOfficeConnector> {
  constructor(protected apiFactory: ReturnType<typeof BackOfficeConnector.Factory>, protected eventBus: EventBus) {
    super(apiFactory, eventBus);
  }

  get(id: string) {
    return this.callApi(api => api.all("enforcement").one("tablet_users", id).getEntity(EnforcementTabletUserDetailResponse));
  }

  getAll(
    filters: EnforcementTabletUserSearchRequest,
    pagination: IPagination,
    abortSignal: AbortSignal
  ): Promise<IPagedResults<EnforcementTabletUserSearchRequest>> {
    return this.callApi(api =>
      api
        .all("enforcement")
        .all("tablet_user_search")
        .postPagedEntities(
          { ...serializeFilters(filters, false), ...pagination },
          EnforcementTabletUserSearchRequest,
          abortSignal
        )
    );
  }

  create(entity: EnforcementTabletUserCreateRequest) {
    return this.callApi(api =>
      api
        .all("enforcement")
        .all("tablet_users")
        .postEntity<EnforcementTabletUserCreateRequest>(entity, EnforcementTabletUserCreateRequest)
    );
  }

  update(entity: EnforcementTabletUserResponse) {
    return this.callApi(api =>
      api.all("enforcement").one("tablet_users", entity.id).putEntity(entity, EnforcementTabletUserDetailResponse)
    );
  }

  delete(entity: EnforcementTabletUserResponse) {
    return this.callApi(api => api.all("enforcement").one("tablet_users", entity.id).delete(entity));
  }
}
